import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Row, Button } from "reactstrap";

function Header(props) {
	const { title, headerBorder, navigateBack } = props;
	return (
		<>
			{navigateBack ? ( //back button and title
				<Row className="topBar ml-2">
					<Button
						title="Go Back"
						type="button"
						className="backBtn ml-n1"
						onClick={navigateBack}
					>
						<FontAwesomeIcon icon={faChevronLeft} size="1x" />
					</Button>
					<div className="col-lg-8 col-md-8 col-sm-12 mr-auto mt-2 mt-md-0  title">
						{title}
					</div>
				</Row>
			) : (
				//title only
				<Row className="topBar">
					<div className="col-lg-12 col-md-8 col-sm-12 mr-auto mt-2 mt-md-0 title">
						{title}
					</div>
				</Row>
			)}
			{headerBorder ? <hr /> : null}
		</>
	);
}

export default Header;
